import {
    PesquisaSatisfacaoFornecedorInicial,
    type PesquisaSatisfacaoFornecedorModel,
} from "../models/pesquisaSatisfacaoFornecedorModel"
import {
    PesquisaSatisfacaoFornecedorActionsTypes,
    type PesquisaSatisfacaoFornecedorActionModel,
} from "./pesquisaSatisfacaoFornecedorActions"

export function pesquisaSatisfacaoFornecedorReducer(
    state: PesquisaSatisfacaoFornecedorModel,
    action: PesquisaSatisfacaoFornecedorActionModel
): PesquisaSatisfacaoFornecedorModel {
    switch (action.type) {
        case PesquisaSatisfacaoFornecedorActionsTypes.CARREGAR:
            return {
                ...state,
                itens: action.payload.itens,
                comentarios: action.payload.comentarios,
                total: action.payload.total,
            }

        case PesquisaSatisfacaoFornecedorActionsTypes.ATUALIZAR_INICIO:
            return { ...state, inicioMs: action.payload }

        case PesquisaSatisfacaoFornecedorActionsTypes.ATUALIZAR_FIM:
            return { ...state, fimMs: action.payload }

        default:
            return state
    }
}

export { PesquisaSatisfacaoFornecedorInicial }
